import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $isHighlight?: boolean }>`
	border: 1px solid ${({ theme }) => theme.colors.transparent.light10};
	border-radius: 12px;

	display: grid;
	grid-template-columns: 184px repeat(2, 1fr);
	grid-template-rows: 1fr;

	${({ $isHighlight }) =>
		$isHighlight &&
		css`
			border: 1px solid ${({ theme }) => theme.colors.transparent.light30};

			box-shadow: 0px 0px 9.3px 0px rgba(255, 255, 255, 0.09);
		`}

	@media (max-width: 992px) {
		grid-template-columns: 90px 1fr 1fr;
	}
`;

export const Place = styled.div`
	display: flex;
	gap: 8px;
	align-items: center;

	font-size: 18px;
	line-height: 25px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.title};

	padding: 30px 20px;

	@media (max-width: 992px) {
		padding: 16px 7px 16px 13px;
		font-size: 12px;
		line-height: 16px;
	}
`;

export const CrownIconWrapper = styled.div<{ $isActive?: boolean }>`
	width: 20px;
	height: 20px;

	svg {
		width: 20px;
		height: 20px;
	}

	path {
		fill: ${({ theme }) => theme.colors.icon.alwaysWhite};

		${({ $isActive }) =>
			$isActive &&
			css`
				fill: ${({ theme }) => theme.colors.icon.main};
			`}
	}

	@media (max-width: 992px) {
		width: 16px;
		height: 16px;

		svg {
			width: 16px;
			height: 16px;
		}
	}
`;

export const Participant = styled.div`
	padding: 30px 20px;
	font-size: 18px;
	line-height: 25px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.title};

	@media (max-width: 992px) {
		padding: 16px 12px;
		font-size: 12px;
		line-height: 16px;
	}
`;

export const Prize = styled.div`
	padding: 30px 20px;
	font-size: 18px;
	line-height: 25px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.title};
	display: flex;
	gap: 8px;
	align-items: center;

	@media (max-width: 992px) {
		padding: 16px 12px;
		font-size: 12px;
		line-height: 16px;
	}
`;

export const CupIconWrapper = styled.div`
	width: 24px;
	height: 24px;

	svg {
		width: 24px;
		height: 24px;
	}

	path {
		fill: ${({ theme }) => theme.colors.icon.main};
	}

	@media (max-width: 992px) {
		display: none;
	}
`;
